import { getBaseRole } from '@/helpers/customRoles';
import { timetableBeta } from "@/api";
import { setTimetableData, setTimetableDataLoading, setTimetableDataError, resetReportsIdsForMassActions, setAudienceFilterMetadata } from "./timetableSlice";
import { typesEnum } from '@pages/Main/Timetable/components/Types/typesEnum';
import { periodModes } from "@pages/Main/Timetable/components/PeriodMode/periodModes";
import store from "@store/redux.store";
import rolesEnum from "@/constant/rolesEnum";
import { fetchWorkingHoursSelectedEmployees } from "./fetchWorkingHoursSelectedEmployees";
import dayjs from "@store/timetable/dayjs.config";
import { addBoundaryOvernightReports } from "../../components/pages/Main/Timetable/components/Main/helpers/addThereIsCrossroadAtOneHourOnOneDay";
import { convertTimetableData, getTimetableDates, getTimetableRequestRange, getTimetableTimeZones, mergeDailyTimetableData } from "@/helpers/new/time/timetableTimeZone";

let latestRequestId = 0;

export const fetchTimetableData = ({addMe, typeAll} = {}) => async (dispatch, getState) => {
  const requestId = ++latestRequestId;
  dispatch(setTimetableDataLoading(true))
  const { filters, weekRange, day, type, periodMode, isTimeZoneEnabled } = getState().timetable;
  const isOneDay = type === typesEnum.oneDay;
  const isManualDayMode = periodMode === periodModes.day;
  const { platformTimeZone, timeZone } = isTimeZoneEnabled === true ? getTimetableTimeZones(
    getState().settings.custom?.timezone,
  ) : {};
  const convertTime = isTimeZoneEnabled === true && platformTimeZone !== timeZone;
  const isCurrentRequest = () => requestId === latestRequestId
    && getState().timetable.type === type
    && (getState().timetable.isTimeZoneEnabled === true) === (isTimeZoneEnabled === true);

  
  try {
    const api = isOneDay ? timetableBeta.getDailyTimetableDataСancel : timetableBeta.getWeeklyTimetableDataСancel;
    
    const displayStart = isOneDay || isManualDayMode ? day : weekRange.start;
    const displayEnd = isOneDay || isManualDayMode ? day : weekRange.end;
    const requestedStart = isOneDay ? null : displayStart;
    const params = getParams({filters, weekRange, day, type, addMe, typeAll, periodMode});
    const requestRange = convertTime
      ? getTimetableRequestRange(displayStart, displayEnd, platformTimeZone, timeZone)
      : null;
    if (requestedStart && params) {
        params.start = requestRange?.start ?? dayjs(requestedStart).subtract(1, 'day').format('YYYY-MM-DD');
        if (requestRange) params.end = requestRange.end;
    }
    const result = isOneDay && requestRange
      ? await api(params, getTimetableDates(requestRange.start, requestRange.end))
      : await api(params);
    if (!isCurrentRequest()) return;
    const responses = Array.isArray(result) ? result : [result];
    const response = responses[0];
    const loadedData = Array.isArray(result) ? mergeDailyTimetableData(responses) : response.data.data;
    const displayData = convertTime ? convertTimetableData(loadedData, {
      start: displayStart, end: displayEnd, platformTimeZone, timeZone, isOneDay,
    }) : loadedData;

    const timetableData = addBoundaryOvernightReports(displayData, requestedStart);
    const audiences = Array.isArray(result)
      ? [...new Map(responses.flatMap((item) => item.data.audiences ?? [])
        .map((audience) => [audience.id, audience])).values()]
      : response.data.audiences ?? [];

    dispatch(setTimetableData(timetableData));
    dispatch(setAudienceFilterMetadata({
      options: audiences.map((audience) => ({
        value: audience.id,
        label: audience.name
      })),
      hasAudienceLessons: responses.some((item) => item.data.hasAudienceLessons === true
        || Number(item.data.hasAudienceLessons) === 1)
    }));
    dispatch(resetReportsIdsForMassActions())
    dispatch(setTimetableDataError(null))
    if (!isManualDayMode) {
      dispatch(fetchWorkingHoursSelectedEmployees())
    }
  } catch (error) {
    if (isCurrentRequest()) dispatch(setTimetableDataError(error))
  } finally {
    if (isCurrentRequest()) dispatch(setTimetableDataLoading(false))
  }
};


export const getParams = ({filters, weekRange, day, type, addMe, typeAll, periodMode}) => {
    const finalFilters = getBaseRole(store.getState()?.profile?.profile?.role) === rolesEnum.seminarian ? {
      ...filters,
      seminarians: [store.getState()?.profile?.profile?.id]
    } 
    : 
    {
      ...filters,
      seminarians: !!filters?.direction ? 
                  filters?.seminariansInCourses : 
                  addMe ? [...filters?.seminarians, store.getState()?.profile?.profile?.id] : filters?.seminarians
    };
    if(getBaseRole(store.getState()?.profile?.profile?.role) === rolesEnum.parent) {
      if(!store.getState()?.parentSelectedChildId) return;
      finalFilters.childrens = [store.getState()?.parentSelectedChildId];
    }

    const isOneDay = type === typesEnum.oneDay;
    const isManualDayMode = periodMode === periodModes.day;

    const params = { 
        filters: finalFilters,
        ...(isOneDay ? {day} : isManualDayMode ? {start: day, end: day} : weekRange),
        type: typeAll && !typesEnum.isAdditional(type) ? typesEnum.all : type
    }

    if (typesEnum.isAdditional(type)) {
      params.filters = {
        ...params.filters,
        additionalScheduleTabId: typesEnum.additionalId(type)
      };
    }

    return params;
}
